<template>
  <section class="services-brands">
    <div class="row justify-content-end align-items-center  d-xs-block">
      <div class="col-md-2 col colors-brand mb-4 mb-md-0">
        <div class="services org">
          <span style="font-size: 1.7rem">services</span>
        </div>
      </div>
      <div class="col-md-10 col d-md-flex d-block">
        <div
          v-for="service of services"
          v-bind:key="service._id"
          class="service col-12 col-sm-12 col-md-4 col-lg-3"
        >
          <div class="img-container">
            <img
              v-bind:src="
                'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                  service.image
              "
              style=""
            />
          </div>
          <div class="texts">
            <p class="h4">{{ service.title }}</p>
            <p class="lead">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-end align-items-center brandds d-xs-block">
      <div class="col-md-2 col colors-brand">
        <div class="services pink">
          <span style="font-size: 1.7rem">Top brands</span>
        </div>
      </div>
      <div class="col-md-10">
        <BrandsSlider />
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import BrandsSlider from "@/components/BrandsSlider";
export default {
  components: {
    BrandsSlider,
  },
  data() {
    return {
      services: [],
    };
  },
  created() {
    this.getServices();
  },
  methods: {
    getServices() {
      axios.get("https://api.ardunic.com/v1/services").then((res) => {
        this.services = res.data.data;
      });
    },
  },
};
</script>

<style scoped>
.colors-brand {
}

.services {
  padding: 15px;
  border-radius: 0px 56px 56px 0px;
  text-transform: capitalize;
  color: white;
}

.services-brands {
  margin-top: 100px;
}
.services-brands.services {
  color: white;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  padding: 30px;
}
.services-brands.services span {
  font-size: 1.8rem;
}
.org {
  background: linear-gradient(to right, #f6893a, #fdbd5d);
}

.pink {
  background: linear-gradient(to right, #ff54af, #ffb677);
}

.service {
  display: flex;
  margin-right: 100px;
}
.service .img-container img {
  width: 3rem;
}

.service .texts {
  margin-left: 15px;
}
.brandds {
  margin-top: 40px;
}
</style>
